<template>
  <div>
    <v-card
      ><v-card-text>
        <menuSuperviseur />

        Présence Formations pour l'activité {{ $route.query.ll_parcours }}

        <v-card-text>
          <div class="h4">
            {{ $route.query.abbr_bailleur }} - {{ $route.query.ll_bailleur }}
          </div>
          <div class="h4">
            {{ $route.query.ll_theme }} - {{ $route.query.ll_parcours }}
          </div>
        </v-card-text>
        <v-card-actions>
          <v-container fluid>
            <v-row align="center">
              <v-col class="my-0 py-0">
                <v-btn
                  class="blue mx-4"
                  dark
                  :loading="loading"
                  @click="getPresencesFormations()"
                >
                  Afficher les données</v-btn
                >
              </v-col>
            </v-row>
          </v-container>
        </v-card-actions>
        <v-card-text>
          <div>Nombre: {{ formations.length }} présents</div>
          <div>
            Nombre sans doublons:
            {{ formationsSansDoublons.length }} personnes
          </div>

          <vue-excel-xlsx
            class="mt-4"
            v-if="formations.length > 0"
            :data="formations"
            :columns="headers"
            :filename="'formations' + Date.now()"
            :sheetname="'formations'"
          >
            <v-btn class="green" dark>
              <v-icon class="mr-2">mdi-microsoft-excel</v-icon>
              Télécharger les
              {{ formations.length }} résultats</v-btn
            >
          </vue-excel-xlsx>

          <v-data-table
            dense
            :headers="headers"
            :items="formations"
            locale="fr"
            :items-per-page="50"
          >
            <template v-slot:item.sexe="{ item }">
              {{ getSexe(item.sexe) }}
            </template>
          </v-data-table>
        </v-card-text>
      </v-card-text>
      <v-card-actions>
        <Navigation :elements="SuperviseurNavigation" />
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      formations: [],
      formationsSansDoublons: [],
      loading: false,
      headers: [
        {
          text: "Id",
          value: "membres_id_membre",
          label: "Id",
          field: "membres_id_membre",
        },
        {
          text: "Nom",
          label: "Nom",
          value: "nom",
          field: "nom",
        },
        {
          text: "Année de naissance",
          label: "Année de naissance",
          value: "annee_naissance",
          field: "annee_naissance",
        },
        {
          text: "Sexe",
          value: "sexe",
          label: "Sexe",
          field: "sexe",
          dataFormat: this.getSexe,
        },

        {
          text: "Groupe",
          label: "Groupe",
          value: "nom_groupe",
          field: "nom_groupe",
        },
        {
          text: "Formation",
          label: "Formation",
          value: "ll_formation_groupe",
          field: "ll_formation_groupe",
        },
        {
          text: "Date",
          label: "Date",
          value: "date_formation_groupe",
          field: "date_formation_groupe",
        },

        {
          text: "Projet",
          label: "Projet",
          value: "ll_programme",
          field: "ll_programme",
        },
        {
          text: "Activité",
          label: "Activité",
          value: "ll_parcours",
          field: "ll_parcours",
        },
        /*  {
          text: "id_activite",
          label: "id_activite",
          value: "parcours_id_parcours",
          field: "parcours_id_parcours",
        },
        {
          text: "id_projet",
          label: "id_projet",
          value: "programmes_id_programme",
          field: "programmes_id_programme",
        }, */
        {
          text: "Animateur",
          label: "Animateur",
          value: "nom_responsable",
          field: "nom_responsable",
        },
        {
          text: "Région",
          value: "ll_region",
          label: "Région",
          field: "ll_region",
        },
        {
          text: "District",
          value: "ll_district",
          label: "District",
          field: "ll_district",
        },
        {
          text: "Commune",
          value: "ll_commune",
          label: "Commune",
          field: "ll_commune",
        },
        {
          text: "Fokontany",
          value: "ll_fokontany",
          label: "Fokontany",
          field: "ll_fokontany",
        },
        {
          text: "Village",
          value: "village",
          label: "Village",
          field: "village",
        },
      ],
    };
  },
  created() {},
  components: {
    menuSuperviseur: require("@/components/superviseur/menuSuperviseur.vue")
      .default,
    Navigation: require("@/components/Navigation.vue").default,
  },
  methods: {
    getSexe(sexe) {
      if (sexe == "1") {
        return "Masculin";
      } else {
        return "Féminin";
      }
    },
    getPresencesFormations() {
      let self = this;
      self.formations = [];
      self.formationsSansDoublons = [];
      self.loading = true;
      this.$firebase
        .firestore()
        .collection("presencesFormationsGroupes")
        .where("parcours_id_parcours", "==", self.$route.query.id)
        .where(
          "programmes_id_programme",
          "==",
          self.$route.query.programmes_id_programme
        )
        .get()
        .then(
          (snapshot) => {
            snapshot.forEach(function (doc) {
              self.formations.push({
                ...doc.data(),
                id: doc.id,
              });
            });

            self.formationsSansDoublons = _.uniqBy(
              self.formations,
              "membres_id_membre"
            );

            self.loading = false;
          },
          (error) => {
            console.log(error);
          }
        );
    },
  },
  computed: {
    ...mapState({
      SuperviseurNavigation: (state) => state.Navigation.SuperviseurNavigation,
      user: (state) => state.Auth.user,
    }),
  },
};
</script>

<style lang="scss" scoped></style>
